package org.beatonma.orbitals.compose.ui.components.icons


object OrbitalsIcons
